import { BottomSheetModal } from '@gorhom/bottom-sheet'
import React, { useMemo } from 'react'
import { ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native'

import { ProgramItem } from 'partials/WhereToBottomSheet/ProgramItem'

import { Avatar } from 'widgets/Avatar'
import { BottomSheetModalBackdrop } from 'widgets/BottomSheetModalBackdrop'
import { Box } from 'widgets/Box'
import { EmptyHandleComponent } from 'widgets/EmptyHandleComponent'
import { Separator } from 'widgets/Separator'
import { Text } from 'widgets/Text'
import { Title } from 'widgets/Title'

import { links } from 'utils/constants'

const styles = StyleSheet.create({
  bottomSheet: {
    paddingTop: 10,
  },
  bottomSheetContent: {
    flex: 1,
    alignItems: 'center',
  },
  separator: {
    borderColor: '#ececec',
    borderWidth: 1,
    width: '100%',
    marginVertical: 8,
  },
  sharedToRow: {
    width: '100%',
    paddingHorizontal: 16,
  },
})

export const WhereToBottomSheet = ({ bottomSheetRef, creator, navigation, programs }) => {
  const snapPoints = useMemo(() => [350], [])

  return (
    <BottomSheetModal
      ref={bottomSheetRef}
      index={0}
      snapPoints={snapPoints}
      style={styles.bottomSheet}
      handleComponent={EmptyHandleComponent}
      backdropComponent={BottomSheetModalBackdrop}
      enableHandlePanningGesture={false}
      enableContentPanningGesture={false}
    >
      <View style={styles.bottomSheetContent}>
        <Title bold>Shared To...</Title>
        <Text color='greyDark' fontSize='xs' isCompact>
          To see more content like this,
        </Text>
        <Text color='greyDark' fontSize='xs' isCompact>
          you can follow the creator or join these Groups
        </Text>
        <Separator />
        <View style={styles.separator} />
        <Box flexDirection='row' testID='SharedToRow' style={styles.sharedToRow}>
          <Box flexDirection='column' testID='CreatorColumn' width='33%'>
            <Box flexDirection='column' width={80}>
              <Text bold fontSize='md'>
                Creator
              </Text>
              <TouchableOpacity
                onPress={() => {
                  bottomSheetRef?.current?.dismiss()
                  navigation.navigate(links.PROFILE_STACK, {
                    screen: links.MEMBER_PROFILE_PAGE,
                    params: { username: creator?.username },
                  })
                }}
              >
                <Box margin={{ vertical: 16 }}>
                  <Avatar width={80} height={80} image={creator?.avatar} />
                </Box>
                <Box flexDirection='column' align='center'>
                  <Text
                    fontSize='xs'
                    bold
                    numberOfLines={1}
                  >{`${creator?.firstName} ${creator?.lastName}`}</Text>
                  <Text fontSize='xs' numberOfLines={1}>
                    {creator?.username}
                  </Text>
                </Box>
              </TouchableOpacity>
            </Box>
          </Box>
          <Box flexDirection='column' testID='UpspacesColumn'>
            {programs.length > 0 && (
              <>
                <Box flexDirection='row' testID='TitleRow'>
                  <Text bold fontSize='md'>
                    Groups
                  </Text>
                </Box>
                <Box flexDirection='row' testID='UpspacesRow'>
                  <ScrollView
                    contentContainerStyle={{ width: 136 * (programs?.length ?? 2) }}
                    horizontal
                  >
                    {programs?.map((program) => (
                      <ProgramItem key={program.id} program={program} navigation={navigation} />
                    ))}
                  </ScrollView>
                </Box>
              </>
            )}
          </Box>
        </Box>
      </View>
    </BottomSheetModal>
  )
}
